import { withHandlers, compose, withState, lifecycle } from 'recompose'
import { isMobile, isTablet } from 'components/common/Media/helpers'
import debounce from 'lodash/debounce'

const evalDevice = () => isMobile()
  ? isTablet() ? 'TABLET' : 'PHONE'
  : 'DESKTOP'

const withMobileState = withState('deviceType', 'setDeviceType', evalDevice())

const withHandleResize = withHandlers({
  handleResize: ({ setDeviceType }) =>
    debounce(() => setDeviceType(evalDevice()), 500)
})

const withLifecycle = lifecycle({
  componentDidMount() {
    const { handleResize } = this.props
    window.addEventListener('resize', handleResize)
  },
  componentWillUnmount() {
    const { handleResize } = this.props
    window.removeEventListener('resize', handleResize)
  }
})

export default compose(
  withMobileState,
  withHandleResize,
  withLifecycle
)
